module.exports = __webpack_public_path__ + "static/media/jp.d139773b.svg";